import * as React from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

/**
 * Industrial-themed wrapper around shadcn Select.
 * options: [{ value, label }]
 */
export function LLSelect({
  value,
  onChange,
  options,
  placeholder = "Select…",
  className = "",
  testId,
  contentTestId,
}) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger
        data-testid={testId}
        className={`!w-auto h-auto py-2 px-3 bg-[#1a1a1a] border border-[#2a2a2a] text-white rounded-none focus:border-[#ff8c00] focus:ring-0 focus:ring-offset-0 text-xs uppercase tracking-wider data-[placeholder]:text-[#71717a] shadow-none hover:border-[#4d4d4d] transition-colors gap-2 ${className}`}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent
        data-testid={contentTestId}
        className="bg-[#0d0d0d] border border-[#4d4d4d] rounded-none text-white shadow-none"
      >
        {options.map((opt) => (
          <SelectItem
            key={String(opt.value)}
            value={String(opt.value)}
            disabled={!!opt.disabled}
            className="rounded-none text-xs uppercase tracking-wider focus:bg-[#ff8c00] focus:text-black data-[state=checked]:bg-[#ff8c00]/15 data-[state=checked]:text-[#ff8c00] data-[disabled]:opacity-40 data-[disabled]:cursor-not-allowed cursor-pointer"
            data-testid={`${testId}-option-${opt.value}`}
          >
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
